// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Composite API
 * HTTP API for managing Neo4j composite database instances.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  EchoHTTPError,
  HandlersAliasResponse,
  HandlersCompositeInstanceInternalResponse,
  HandlersPatchCompositeInstanceInternalRequest,
  HandlersPatchCompositeInstancesInternalRequest,
  HandlersPatchCompositeInstancesInternalResponse,
} from '../models/index';
import {
  EchoHTTPErrorFromJSON,
  EchoHTTPErrorToJSON,
  HandlersAliasResponseFromJSON,
  HandlersAliasResponseToJSON,
  HandlersCompositeInstanceInternalResponseFromJSON,
  HandlersCompositeInstanceInternalResponseToJSON,
  HandlersPatchCompositeInstanceInternalRequestFromJSON,
  HandlersPatchCompositeInstanceInternalRequestToJSON,
  HandlersPatchCompositeInstancesInternalRequestFromJSON,
  HandlersPatchCompositeInstancesInternalRequestToJSON,
  HandlersPatchCompositeInstancesInternalResponseFromJSON,
  HandlersPatchCompositeInstancesInternalResponseToJSON,
} from '../models/index';

export interface GetCompositeInstancePortalRequest {
  id: string;
}

export interface ListAliasesInternalRequest {
  id: string;
  showDeleted?: boolean;
}

export interface ListCompositeInstancesInternalRequest {
  showDeleted?: boolean;
}

export interface PatchCompositeInstanceInternalRequest {
  id: string;
  request: HandlersPatchCompositeInstanceInternalRequest;
}

export interface PatchCompositeInstancesInternalRequest {
  request: HandlersPatchCompositeInstancesInternalRequest;
}

/**
 *
 */
export class InternalCompositesApi extends runtime.BaseAPI {
  /**
   * Get composite instance by ID (internal portal)
   */
  async getCompositeInstancePortalRaw(
    requestParameters: GetCompositeInstancePortalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<HandlersCompositeInstanceInternalResponse>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling getCompositeInstancePortal().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/internal/v1/portal/composites/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      HandlersCompositeInstanceInternalResponseFromJSON(jsonValue),
    );
  }

  /**
   * Get composite instance by ID (internal portal)
   */
  async getCompositeInstancePortal(
    requestParameters: GetCompositeInstancePortalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<HandlersCompositeInstanceInternalResponse> {
    const response = await this.getCompositeInstancePortalRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Lists aliases for a composite instance. Bypasses project filtering; not exposed on the public API. Optionally includes soft-deleted aliases.
   * List aliases for a composite instance (internal portal)
   */
  async listAliasesInternalRaw(
    requestParameters: ListAliasesInternalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<HandlersAliasResponse>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling listAliasesInternal().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['showDeleted'] != null) {
      queryParameters['showDeleted'] = requestParameters['showDeleted'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/internal/v1/portal/composites/{id}/aliases`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(HandlersAliasResponseFromJSON),
    );
  }

  /**
   * Lists aliases for a composite instance. Bypasses project filtering; not exposed on the public API. Optionally includes soft-deleted aliases.
   * List aliases for a composite instance (internal portal)
   */
  async listAliasesInternal(
    requestParameters: ListAliasesInternalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<HandlersAliasResponse>> {
    const response = await this.listAliasesInternalRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Internal listing of composite instances. Optionally includes soft-deleted instances.
   * List composite instances (internal)
   */
  async listCompositeInstancesInternalRaw(
    requestParameters: ListCompositeInstancesInternalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<
    runtime.ApiResponse<Array<HandlersCompositeInstanceInternalResponse>>
  > {
    const queryParameters: any = {};

    if (requestParameters['showDeleted'] != null) {
      queryParameters['showDeleted'] = requestParameters['showDeleted'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/internal/v1/portal/composites`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(HandlersCompositeInstanceInternalResponseFromJSON),
    );
  }

  /**
   * Internal listing of composite instances. Optionally includes soft-deleted instances.
   * List composite instances (internal)
   */
  async listCompositeInstancesInternal(
    requestParameters: ListCompositeInstancesInternalRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<HandlersCompositeInstanceInternalResponse>> {
    const response = await this.listCompositeInstancesInternalRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Patches CompositeDatabase CR spec (memory and/or neo4jVersion). Bypasses project filtering; not exposed on the public API. At least one field is required.
   * Patch composite instance spec (internal)
   */
  async patchCompositeInstanceInternalRaw(
    requestParameters: PatchCompositeInstanceInternalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling patchCompositeInstanceInternal().',
      );
    }

    if (requestParameters['request'] == null) {
      throw new runtime.RequiredError(
        'request',
        'Required parameter "request" was null or undefined when calling patchCompositeInstanceInternal().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/internal/v1/portal/composites/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: HandlersPatchCompositeInstanceInternalRequestToJSON(
          requestParameters['request'],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Patches CompositeDatabase CR spec (memory and/or neo4jVersion). Bypasses project filtering; not exposed on the public API. At least one field is required.
   * Patch composite instance spec (internal)
   */
  async patchCompositeInstanceInternal(
    requestParameters: PatchCompositeInstanceInternalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.patchCompositeInstanceInternalRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   * Patches CompositeDatabase CR spec (memory and/or neo4jVersion) for multiple instances. Bypasses project filtering; not exposed on the public API. At least one patch field and one instance id are required. Returns per-instance results.
   * Patch multiple composite instance specs (internal)
   */
  async patchCompositeInstancesInternalRaw(
    requestParameters: PatchCompositeInstancesInternalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<
    runtime.ApiResponse<HandlersPatchCompositeInstancesInternalResponse>
  > {
    if (requestParameters['request'] == null) {
      throw new runtime.RequiredError(
        'request',
        'Required parameter "request" was null or undefined when calling patchCompositeInstancesInternal().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/internal/v1/portal/composites/batch`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: HandlersPatchCompositeInstancesInternalRequestToJSON(
          requestParameters['request'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      HandlersPatchCompositeInstancesInternalResponseFromJSON(jsonValue),
    );
  }

  /**
   * Patches CompositeDatabase CR spec (memory and/or neo4jVersion) for multiple instances. Bypasses project filtering; not exposed on the public API. At least one patch field and one instance id are required. Returns per-instance results.
   * Patch multiple composite instance specs (internal)
   */
  async patchCompositeInstancesInternal(
    requestParameters: PatchCompositeInstancesInternalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<HandlersPatchCompositeInstancesInternalResponse> {
    const response = await this.patchCompositeInstancesInternalRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
